export class ExchangeFees {
    #exchangeAssets;
    #fees;
    #feeMonitors;
    constructor(params) {
        this.#exchangeAssets = params.exchangeAssets;
        this.#fees = params.fees;
        this.#feeMonitors = params.feeMonitors;
    }
    getFeeOpts = async (params) => {
        const asset = this.#exchangeAssets.getAsset({ assetId: params.assetId });
        const feeData = await this.#feeMonitors.getFeeData({ assetName: asset.baseAsset.name });
        const fees = await this.#fees.getFees({
            assetName: asset.name,
            ...params,
            isSendAll: false,
        });
        return { ...feeData, ...fees };
    };
    getFees = async (params) => {
        const asset = this.#exchangeAssets.getAsset({ assetId: params.assetId });
        try {
            const fee = await this.#fees.getFees({
                assetName: asset.name,
                ...params,
            });
            return fee.fee;
        }
        catch (err) {
            console.error('Failed to get fees', err);
            return asset.feeAsset.currency.ZERO;
        }
    };
}
const exchangeFeesFactory = (args) => new ExchangeFees({ ...args });
const exchangeFeesModuleDefinition = {
    id: 'exchangeFees',
    type: 'module',
    factory: exchangeFeesFactory,
    dependencies: ['exchangeAssets', 'feeMonitors', 'fees'],
};
export default exchangeFeesModuleDefinition;
